<template>
  <section class="how-it-works" id="howItWorks">
    <!-- Header -->
    <h2>{{ $t("message.steps_title") }}</h2>
    <p class="subtitle">{{ $t("message.steps_sub_title") }}</p>

    <!-- FOR LOCAL GUIDES -->
    <div class="row" id="forLocalGuides">
      <div class="image-box">
        <img src="@/assets/images/LocalHost.png" alt="Local guide" />
      </div>

      <div class="content">
        <h3>{{ $t("message.steps_localguide_title") }}</h3>

        <div class="step">
          <div class="circle">1</div>
          <div>
            <h4>{{ $t("message.steps_localguide_steps_title1") }}</h4>
            <p>{{ $t("message.steps_localguide_steps_description1") }}</p>
          </div>
        </div>

        <div class="step">
          <div class="circle">2</div>
          <div>
            <h4>{{ $t("message.steps_localguide_steps_title2") }}</h4>
            <p>{{ $t("message.steps_localguide_steps_description2") }}</p>
          </div>
        </div>

        <div class="step">
          <div class="circle">3</div>
          <div>
            <h4>{{ $t("message.steps_localguide_steps_title3") }}</h4>
            <p>{{ $t("message.steps_localguide_steps_description3") }}</p>
          </div>
        </div>

        <div class="step">
          <div class="circle">4</div>
          <div>
            <h4>{{ $t("message.steps_localguide_steps_title4") }}</h4>
            <p>{{ $t("message.steps_localguide_steps_description4") }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- FOR TRAVELERS -->
    <div class="row reverse" id="forTraveler">
      <div class="image-box">
        <img src="@/assets/images/Traveler.png" alt="Travelers" />
      </div>
      <div class="content">
        <h3>{{ $t("message.steps_traveler_title") }}</h3>

        <div class="step">
          <div class="circle">1</div>
          <div>
            <h4>{{ $t("message.steps_traveler_steps_title1") }}</h4>
            <p>{{ $t("message.steps_traveler_steps_description1") }}</p>
          </div>
        </div>

        <div class="step">
          <div class="circle">2</div>
          <div>
            <h4>{{ $t("message.steps_traveler_steps_title2") }}</h4>
            <p>{{ $t("message.steps_traveler_steps_description2") }}</p>
          </div>
        </div>

        <div class="step">
          <div class="circle">3</div>
          <div>
            <h4>{{ $t("message.steps_traveler_steps_title3") }}</h4>
            <p>{{ $t("message.steps_traveler_steps_description3") }}</p>
          </div>
        </div>

        <div class="step">
          <div class="circle">4</div>
          <div>
            <h4>{{ $t("message.steps_traveler_steps_title4") }}</h4>
            <p>{{ $t("message.steps_traveler_steps_description4") }}</p>
          </div>
        </div>
      </div>

      
    </div>
  </section>
</template>
<style scoped>
.how-it-works {
  padding: 80px 24px;
  max-width: 1200px;
  margin: 0 auto;
}

h2 {
  text-align: center;
  font-size: 40px;
  margin-bottom: 8px;
}

.subtitle {
  text-align: center;
  font-size: 18px;
  color: #555;
  margin-bottom: 70px;
}

/* ✅ DESKTOP LAYOUT */
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  margin-bottom: 100px;
  flex-wrap: nowrap; /* IMPORTANT */
}

.row.reverse {
  flex-direction: row-reverse;
}

/* ✅ Force equal width */
.image-box,
.content {
  flex: 1;
}

.image-box {
  display: flex;
  justify-content: center;
}

.image-box img {
  width: 100%;
  max-width: 420px;
  border-radius: 20px;
  object-fit: contain;
}

.content h3 {
  font-size: 26px;
  margin-bottom: 30px;
}

.step {
  display: flex;
  gap: 18px;
  margin-bottom: 24px;
}

.circle {
  width: 36px;
  height: 36px;
  background: #0f6b4f;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  flex-shrink: 0;
}

.step h4 {
  margin-bottom: 4px;
  font-size: 18px;
}

.step p {
  font-size: 15px;
  color: #555;
  line-height: 1.6;
}

/* ✅ MOBILE ONLY */
@media (max-width: 900px) {
  .row,
  .row.reverse {
    flex-direction: column;
  }

  .image-box {
    order: 1;
  }

  .content {
    order: 2;
  }

  .image-box img {
    max-width: 100%;
  }
}


</style>
